import { Navigate, useLocation } from 'react-router-dom';

function mapSettingsSection(section: string | null): string {
  if (section === 'password' || section === 'account') return 'security';
  if (section === 'security' || section === 'preferences') return section;
  return 'preferences';
}

/** Legacy `/{module}/settings` URLs → profile with the matching section. */
export function LegacyModuleSettingsRedirect() {
  const location = useLocation();
  const slug = location.pathname.split('/').filter(Boolean)[0];
  const params = new URLSearchParams(location.search);
  const section = mapSettingsSection(params.get('section'));
  return <Navigate to={`/${slug}/profile?section=${section}`} replace />;
}
